import styled from "styled-components";

export const VersionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;


    svg {
        padding-left: 5px;
        color: #2c36c0;
        font-size: 1.6rem;

        :hover {
            color: #575fda;
            font-size: 1.9rem;
            cursor: pointer;
        }
    }

`;

export const ErrorContainer = styled.div`
    display: ruby;


    svg {
        padding-left: 5px;
        color: #a71414;
        font-size: 1.6rem;

    }

`;